function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _objectSpread({
        viewBox: "0 0 24 24"
    }, props, {
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 24C23.9075 24 24 18.6275 24 12C24 5.3725 23.9075 0 12 0C0.0924992 0 0 5.3725 0 12C0 18.6275 0.0924992 24 12 24Z",
                fill: "#0A192B"
            }),
            /*#__PURE__*/ _jsx("g", {
                clipPath: "url(#clip0_4429_3134)",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M16.6007 4.76868H19.054L13.694 10.8953L20 19.2307H15.0627L11.196 14.1747L6.77067 19.2307H4.316L10.0493 12.6773L4 4.76934H9.06267L12.558 9.39068L16.6007 4.76868ZM15.74 17.7627H17.0993L8.324 6.16001H6.86533L15.74 17.7627Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_4429_3134",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    }));
};
export default Icon;
